import React from 'react';
import Icon from './Icon';

const TONES = {
  neutral:        { background: 'var(--bg-elev-2)',     color: 'var(--fg)',       border: '1px solid var(--line-soft)' },
  accent:         { background: 'var(--accent-soft)',   color: 'var(--accent)',   border: '1px solid transparent' },
  'accent-strong':{ background: 'var(--accent)',        color: 'var(--accent-on)', border: '1px solid transparent' },
  green:          { background: 'var(--green-soft)',    color: 'var(--green)',    border: '1px solid transparent' },
  outline:        { background: 'transparent',          color: 'var(--fg-muted)', border: '1px solid var(--line)' },
};

const Pill = ({ tone = 'neutral', dot, icon, children, style, onClick, onClose }) => (
  <span
    onClick={onClick}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 99,
      fontFamily: 'var(--font-sans)', fontSize: 12, fontWeight: 500,
      cursor: onClick ? 'pointer' : 'default',
      ...TONES[tone], ...style,
    }}
  >
    {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />}
    {icon && <Icon name={icon} size={12} />}
    {children}
    {onClose && (
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        style={{ background: 'transparent', border: 'none', color: 'currentColor', cursor: 'pointer', padding: 0, marginLeft: 2, display: 'inline-flex', opacity: 0.7 }}
      >
        <Icon name="x" size={11} />
      </button>
    )}
  </span>
);

export default Pill;
